module.exports = __webpack_public_path__ + "img/pr-5.e827468c.png";